export const MAX_FILE_SIZE_MB = 100;
export const SUPPORTED_TYPES = [".csv", ".xlsx", ".parquet"];
